import { VueDraggable } from "vue-draggable-plus";

export default {
    install(app) {
        app.component("VueDraggable", VueDraggable);
    },
};
